import { graphql } from "../../services/wp.api.service";

export const query = `
	mutation updateProfileStatus($input: UpdateWeqProfileInput!) {
		updateWeqProfile(input: $input) {
			weqProfile {
				weqProfileAcfFields {
					profilestatus
				}
			}
		}
	}
`;

const profileStatusMutation = (useMutation, options) => useMutation(
	"updateProfileStatus",
	(input) => graphql({
		query,
		variables: {
			input
		}
	}).
		then(({ data }) => {
			if (data.errors) {
				throw new Error(data.errors[0].message);
			}

			return { data };
		}),
	{
		...options
	}
);

export default profileStatusMutation;
